import OhMyFoodLogo from '../../../assets/svg/OhMyFoodLogo';
import OhMyFoodText from '../../../assets/svg/OhMyFoodText';
import '../../../VendorStyles/VendorRegistrationTopMenuBar.css';


function VendorRegistrationTopMenuBar() {
    return (
        <div className="vendor-registration-topbar-container">
            <div className="vendor-registration-omf-container">
                <OhMyFoodLogo
                    height='50px'
                    width='50px'
                />
                <OhMyFoodText
                    width='156px'
                    height='50px'
                    className={'vendor-registration-omf-text'}
                />
            </div>
        </div>
    );
}

export default VendorRegistrationTopMenuBar;
